import { useMemo } from 'react';
import useUsers from './useUsers';
import { UsersMapType } from '../types/user.type';
import hash from 'object-hash';

type FiltersType = {
    includeDisabled: boolean;
    userRoles: string[];
};

function useUsersMap(filters: Partial<FiltersType> = {}) {
    const memoizedFilters = useMemo(() => filters, [hash(filters)]);

    const { users, loading } = useUsers(memoizedFilters);

    const usersMap = useMemo(() => {
        return users.reduce((acc, curr) => {
            acc[curr.id] = curr;
            return acc;
        }, {} as UsersMapType);
    }, [users]);

    return { usersMap, loading };
}

export default useUsersMap;
